import { render, staticRenderFns } from "./Announcing.vue?vue&type=template&id=4debee74"
import script from "./Announcing.vue?vue&type=script&lang=js"
export * from "./Announcing.vue?vue&type=script&lang=js"
import style0 from "./Announcing.vue?vue&type=style&index=0&id=4debee74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports